import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { getSearchURLForMsaAlias } from 'features/Search/Search.helpers';
import { formatMsaNameFromAlias } from './CitcatLinks.helpers';
import { messages } from './CitcatLinks.messages';

export class CitcatLinks extends Component {
  constructor(props) {
    super(props);
    this.renderLink = this.renderLink.bind(this);
    this.renderComingSoon = this.renderComingSoon.bind(this);
  }

  renderSection(region, cities, comingSoon) {
    const regionName = region.replace(/\b[a-z]/g, x => x.toUpperCase()).replace('-', ' ');
    const comingSoonList = comingSoon || [];
    return (
      <div key={region} className="grid__item 1/2 md-1/3 lg-1/6 color-text-light">
        <h6 className="mb-">{regionName}</h6>
        <ul className="mb">
          {cities.map(this.renderLink)}
          {comingSoonList.map(this.renderComingSoon)}
        </ul>
      </div>
    );
  }

  renderLink(msaAlias) {
    const msaLink = getSearchURLForMsaAlias(msaAlias);
    const msaName = formatMsaNameFromAlias(msaAlias);
    return (
      <li key={msaAlias}>
        <a className="block pv-- color-text-light" href={msaLink}>
          {msaName}
        </a>
      </li>
    );
  }

  renderComingSoon(msaAlias) {
    const msaName = formatMsaNameFromAlias(msaAlias);
    return (
      <li className="pv-- color-text-light" key={msaAlias}>
        <FormattedMessage {...messages.comingSoon} values={{ msaName }} />
      </li>
    );
  }

  render() {
    // TODO i18n
    const locations = [
      ['east-coast', ['baltimore', 'boston', 'new-york', 'philadelphia', 'pittsburgh', 'washington-d.c.']],
      ['southeast', ['atlanta', 'charlotte', 'miami', 'nashville', 'new-orleans', 'orlando', 'raleigh', 'tampa']],
      [
        'midwest',
        [
          'chicago',
          'cincinnati',
          'columbus',
          'denver',
          'indianapolis',
          'kansas-city',
          'milwaukee',
          'minneapolis',
          'st.-louis',
        ],
      ],
      [
        'west-coast',
        [
          'honolulu',
          'inland-empire',
          'los-angeles',
          'missoula',
          'portland',
          'sacramento',
          'salt-lake-city',
          'san-diego',
          'san-francisco',
          'seattle',
        ],
      ],
      ['southwest', ['austin', 'dallas', 'houston', 'las-vegas', 'phoenix', 'san-antonio']],
      [
        'international',
        [
          'adelaide',
          'brisbane',
          'bristol',
          'calgary',
          'germany',
          'hong-kong',
          'india',
          'indonesia',
          'london',
          'malaysia',
          'manchester',
          'melbourne',
          'netherlands',
          'new-zealand',
          'perth',
          'philippines',
          'singapore',
          'sydney',
          'thailand',
          'toronto',
          'united-arab-emirates',
          'vancouver',
        ],
      ],
    ];
    return (
      <div className={`citcat-links bg--${this.props.backgroundColor || 'white'}`}>
        <div className="wrap ph pt+ pb md-ph+ md-pv++">
          <h2 className="gamma text--center mb+">
            <FormattedMessage {...messages.header} />
          </h2>
          <hr className="mt mb+ md-hidden" />
          <div className="grid">{locations.map(section => this.renderSection(section[0], section[1], section[2]))}</div>
        </div>
      </div>
    );
  }
}

CitcatLinks.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
};
